import type { ComponentChildren, JSX } from "preact";
import { cn } from "./cn";

type Props = Omit<JSX.IntrinsicElements["li"], "class"> & {
  // Adds hover state (border-strong + shadow-xs). Disable for static rows that
  // don't have a primary click target.
  interactive?: boolean;
  class?: string;
  children?: ComponentChildren;
};

// Card-style <li> for list rows. Owns border / rounded / bg / hover; layout
// (padding, flex, gap) stays in the consumer so the same primitive serves
// both "icon + text + button" rows and link wrappers.
export function ListItem({
  interactive = true,
  class: className,
  children,
  ...rest
}: Props) {
  return (
    <li
      {...rest}
      class={cn(
        "rounded-lg border border-border bg-bg",
        interactive && "transition hover:border-border-strong hover:shadow-xs",
        className,
      )}
    >
      {children}
    </li>
  );
}
